/**
 * §P.9 · El marco de «Informes».
 *
 * Dos informes en fase 1 y siete más por venir, así que esto es una sección con
 * pestañas desde el principio: añadir el tercero no debería reabrir la discusión de
 * dónde va.
 *
 * El guardián no es el de la sección sino el de cada informe, y por eso está abajo y
 * no aquí: **la asistencia la ve el entrenador y los ingresos no.** Un guardián único
 * en el marco tendría que dejar pasar al entrenador para que viera la asistencia, y
 * entonces «Ingresos» sería una pestaña que le da `403`.
 */
import { Link, Navigate, Outlet, useRouterState } from '@tanstack/react-router';
import { vistasDeInformesPara } from '@/club/secciones';
import { useContextoDelClub } from '@/club/contexto';
import { puedeVerInformes } from '@/club/permisos';

export function MarcoDeInformes() {
  const camino = useRouterState({ select: (s) => s.location.pathname });
  const { rol } = useContextoDelClub();

  if (!puedeVerInformes(rol)) return <Navigate to="/alumnos" replace />;

  return (
    <>
      <nav className="pestañas" aria-label="Informes">
        {vistasDeInformesPara(rol).map((v) => {
          const destino = `/informes/${v.id}`;
          return (
            <Link
              key={v.id}
              to={destino}
              className={
                camino.startsWith(destino) ? 'pestaña-activa' : 'btn-plano'
              }
            >
              {v.etiqueta}
            </Link>
          );
        })}
      </nav>

      <Outlet />
    </>
  );
}
